import React from 'react';
import { useTranslation } from 'react-i18next';
import properties from '../../helpers/config';
import { formatNumber } from '../../lib/modelBuilder/utils/helpers';

interface Props {
  amount: string;
}

const Price = ({ amount }: Props) => {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col lg:flex-row lg:items-baseline">
      <div className="text-4xl text-gray-800">{amount}&nbsp;€</div>
      <div className="text-sm -mt-3 lg:mx-2 italic">
        {t('Tax Incl')}{' '}
        {properties.vat !== undefined
          ? formatNumber(
              (properties.vat - 1) * 100,
              properties.decimalSeparator,
              properties.thousenSeparator,
            ) + '%'
          : null}
      </div>
    </div>
  );
};

export default Price;
